var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"balance"},[_vm._v("\n        Баланс\n        "),_c('span',{staticClass:"data-rows-number"},[_vm._v("\n            "+_vm._s(_vm.formatMoney(this.projectBalance / 100, this.region))+"\n        ")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af8f9418","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/BalanceView.vue
// module id = YCO9
// module chunks = 0